import { render, staticRenderFns } from "./CategoriasProducto.vue?vue&type=template&id=61ee0845&scoped=true"
import script from "./CategoriasProducto.vue?vue&type=script&lang=js"
export * from "./CategoriasProducto.vue?vue&type=script&lang=js"
import style0 from "./CategoriasProducto.vue?vue&type=style&index=0&id=61ee0845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ee0845",
  null
  
)

export default component.exports